export const translations = {
  nav: {
    home: 'Inicio',
    about: 'Nosotros',
    destinations: 'Destinos',
    contact: 'Contacto',
    resources: 'Recursos',
  },
  hero: {
    tagline: 'Creando Momentos Inolvidables en México',
    subheading: 'Celebraciones sin esfuerzo, elegantes e inolvidables en los destinos más impresionantes de México.',
    trusted: '',
  },
  about: {
    heroTitle: 'Assemblage',
    heroSubtitle: 'Creado para lo extraordinario',
    heroDescription: 'Creamos celebraciones únicas para parejas que esperan lo extraordinario.',
    philosophyTitle: 'Nuestra Filosofía',
    philosophyText: 'En Assemblage, creemos que tu boda debe reflejar tu historia: elegante, sin esfuerzo e inolvidable. Nuestro equipo aporta años de experiencia, acceso exclusivo a los mejores lugares de México y un compromiso con la excelencia que nos distingue.',
    founder: 'Fundadora',
    whyAssemblage: '¿Por qué Assemblage?',
    belief: 'Tu historia de amor merece una celebración tan única como tú. En Assemblage Bodas, creamos experiencias extraordinarias con experiencia arraigada y acceso privilegiado a los lugares más impresionantes de México. Desde la visión hasta la ejecución, curamos cada detalle para crear momentos inolvidables.',
   
  },
  contact: {
    heroTitle: 'Comienza tu Celebración a Medida',
    heroDescription: 'Comparte tu visión. Nosotros nos encargamos de lo extraordinario.',
    firstName: 'Nombre*',
    lastName: 'Apellido*',
    name: 'Nombre*',
    email: 'Correo electrónico*',
    whatsapp: 'WhatsApp',
    country: 'País',
    languagePreference: 'Idioma Preferido',
    guestCount: 'Número de Invitados',
    budgetRange: 'Rango de Presupuesto',
    eventDate: 'Fecha preferida del evento',
    location: 'Ubicación preferida',
    notes: 'Cuéntanos tu visión',
    requestConsultation: 'Solicitar Consulta',
    sending: 'Enviando...',
    success: '¡Gracias! Nos pondremos en contacto pronto.',
    error: 'Hubo un error. Por favor, inténtalo de nuevo.',
    preferCall: '¿Prefieres agendar una llamada?',
    bookCalendly: 'Reservar vía Calendly',
    contactUs: 'Contáctanos:',
    title: 'Contáctanos',
    subtitle: 'Comienza tu Viaje',
    formHeaderTitle: 'Comienza Tu Viaje',
    formHeaderSubtitle: 'Comparte tu visión a continuación y nuestros planificadores expertos se pondrán en contacto para hacer realidad tu celebración.',
  },
  destinations: {
    title: 'Nuestros Destinos',
    viewAll: 'Destinos más impresionantes de México, seleccionados para las parejas más exigentes.',
    curatedDestinations: 'Destinos Seleccionados',
    customLocation: 'Ubicación Personalizada',
    customLocationDesc: '¿Tienes una ubicación específica en mente?',
    notFound: 'Destino No Encontrado',
    backToDestinations: 'Volver a Destinos',
    about: 'Acerca de',
    bestTimeToVisit: 'Mejor Época para Visitar',
    diningOptions: 'Opciones de Restaurantes',
    diningDescription: 'Una experiencia culinaria destacada en {destination} con cocina local e internacional.',
    activitiesIn: 'Actividades en',
    activity: 'Actividad',
    activityDescription: 'Descubre una de las mejores experiencias en {destination}.',
    featuredVenues: 'Lugares Destacados',
    venue: 'Lugar',
    exploreOnMap: 'Explorar',
    localTouch: 'Un Toque Local',
    bookConsultation: 'Reservar una Consulta de Destino',
  },
  experience: {
    theAssemblageExperience: 'La Experiencia Assemblage',
    AssemblageDesign: 'Tu Historia, Nuestra Inspiración',
    AssemblageDesignText: 'Comenzamos escuchando: cada detalle de tu visión inspira una celebración inconfundiblemente tuya.',
    localExpertise: 'Acceso Exclusivo',
    localExpertiseText: 'Accede a los venues y rincones más exclusivos de México, reservados para parejas Assemblage.',
    seamlessPlanning: 'Detalles Únicos',
    seamlessPlanningText: 'Desde experiencias personalizadas hasta sorpresas para tus invitados, creamos momentos inolvidables.',
    memories: 'Disfrute Sin Esfuerzo',
    memoriesText: 'Relájate y vive cada instante: nuestro equipo coordina todo para que solo te ocupes de disfrutar.'
  },
  testimonials: {
    loveStories: 'Historias de Amor',
  },
  footer: {
    AssemblageBodas: 'Assemblage Bodas',
    about: 'Nosotros',
    destinations: 'Destinos',
    contact: 'Contacto',
    email: 'Correo',
    whatsApp: 'WhatsApp',
    instagram: 'Instagram',
    allRightsReserved: 'Todos los derechos reservados.',
    partner: 'Conviértete en Socio Assemblage',
  },
  destinationDetail: {
    about: 'Acerca de',
    diningOptions: 'Opciones Gastronómicas',
    activities: 'Actividades',
    featuredVenues: 'Lugares Destacados',
    exploreMap: 'Explorar en el Mapa',
    localTouch: 'Un Toque Local',
    bookConsultation: 'Reservar una Consulta de Destino',
    brandIntro: {
      tagline: "Donde los sueños se convierten en momentos inolvidables",
      title: "Creando Tu Boda Perfecta en México",
      description: "En Assemblage, creemos que cada historia de amor merece una celebración tan única como la pareja. Nuestra profunda conexión con los destinos más encantadores de México nos permite crear bodas que no son solo eventos, sino experiencias inmersivas que capturan la esencia de tu historia de amor.",
      promiseTitle: "Nuestra Promesa",
      promiseText: "Combinamos experiencia local con estándares internacionales para crear celebraciones auténticas y extraordinarias.",
      approachTitle: "Nuestro Enfoque",
      approachText: "Cada detalle se cuida para reflejar tu visión única, abrazando la rica cultura de México.",
      learnMore: "Conoce más sobre nuestra historia"
    },
    why: {
      title: "¿Por qué elegir {destination}?",
      magicTitle: "Vive la Magia de {destination}",
      climate: "Clima y Estaciones",
      accessibility: "Accesibilidad Sin Esfuerzo"
    },
    venues: {
      title: "Lugares de Ensueño en {destination}",
      blurb: "Más allá de lo icónico, nuestro portafolio curado incluye acceso exclusivo a fincas privadas y lugares únicos, asegurando un escenario verdaderamente especial en {destination}.",
      explore: "Explora Lugares con Nosotros"
    },
    experiences: {
      title: "Experiencias para Invitados en {destination}",
      blurbDefault: "Desde atardeceres dorados en la bahía hasta recorridos artísticos privados por calles vibrantes,",
      blurb: "Cada momento en {destination} está diseñado para encantar a tus invitados. Permítenos crear un viaje donde la aventura, la cultura y la celebración se mezclen perfectamente, dejando recuerdos tan inolvidables como tu boda.",
      curated: "Recorridos Curados para Invitados"
    },
    budget: {
      title: "Creando el Presupuesto de Boda en {destination}",
      selected: "Tu presupuesto seleccionado:",
      for: "para",
      default: "(predeterminado)",
      perGuest: "Costo por invitado:",
      reset: "Restablecer a Predeterminado",
      total: "Estimado Total",
      estimate: "Esta es una estimación basada en tu presupuesto y número de invitados seleccionados. Los costos reales pueden variar según tus preferencias y selección de proveedores.",
      quote: "Solicita una Cotización Personalizada",
      allocations: "Estas asignaciones se basan en presupuestos típicos de bodas. Podemos personalizar tu plan para que se adapte a tu visión y prioridades.",
      planning: "Nuestra planificación integral asegura que evites gastos imprevistos, con todos los impuestos, cargos por servicio y permisos claramente detallados desde el principio."
    },
    vendor: {
      title: "Red de Proveedores y Colaboración",
      text: "Nuestras relaciones con los proveedores más destacados de {destination} garantizan calidad incomparable y un historial comprobado, asegurando un proceso colaborativo sin contratiempos para co-planners."
    },
    faq: {
      title: "Preguntas Frecuentes para tu Boda en {destination}",
      q1: "¿Cuál es la mejor época del año para casarse en este destino?",
      a1: "La época ideal depende de tus preferencias. La primavera (marzo-mayo) y el otoño (septiembre-noviembre) ofrecen clima perfecto y temperaturas agradables. El verano puede ser caluroso pero ofrece tarifas más bajas, mientras que el invierno brinda un ambiente mágico con decoraciones festivas.",
      q2: "¿Con cuánta anticipación debemos reservar nuestra boda?",
      a2: "Recomendamos reservar con 12-18 meses de anticipación, especialmente para fechas de temporada alta. Así aseguras disponibilidad de lugares y proveedores preferidos, y tiempo suficiente para una planeación adecuada.",
      q3: "¿Cuáles son los requisitos legales para casarse en México?",
      a3: "Navegar los requisitos legales para bodas internacionales en México puede ser complejo. Nuestros expertos internos gestionan toda la documentación y coordinación para ceremonias civiles y religiosas, brindando total tranquilidad. Para una ceremonia legal, necesitarás pasaportes válidos, actas de nacimiento y prueba de soltería. Nosotros gestionamos todo y coordinamos con las autoridades locales para asegurar un proceso fluido.",
      q4: "¿Pueden ayudar con alojamiento y transporte para los invitados?",
      a4: "¡Por supuesto! Trabajamos con una selección curada de hoteles y servicios de transporte para crear tarifas grupales especiales y logística sin complicaciones para tus invitados.",
      q5: "¿Qué pasa si llueve el día de nuestra boda?",
      a5: "Todos nuestros lugares cuentan con hermosas alternativas interiores y siempre tenemos un plan B. Monitoreamos el clima y hacemos los ajustes necesarios para que tu día sea perfecto.",
      q6: "¿Ofrecen servicios de planeación parcial?",
      a6: "Sí, ofrecemos varios paquetes de planeación, desde servicio completo hasta coordinación del día. Podemos personalizar nuestros servicios según tus necesidades y presupuesto.",
      q7: "¿En qué idiomas trabajan?",
      a7: "Nuestro equipo habla inglés, español y otros idiomas. Garantizamos comunicación clara con todos los proveedores e invitados durante todo el proceso.",
      q8: "¿Cómo manejan las restricciones alimentarias?",
      a8: "Trabajamos de cerca con nuestros socios de catering para atender todas las necesidades alimentarias. Desde opciones vegetarianas y veganas hasta alergias específicas, nos aseguramos de que todos los invitados estén bien atendidos."
    },
    accommodation: {
      title: "Hoteles, Resorts & Estancias",
      description: "Descubre nuestra selección curada de alojamientos, desde resorts de lujo hasta hoteles boutique, asegurando que tus invitados experimenten la perfecta combinación de comodidad y encanto local.",
      blurb: "Cada propiedad ha sido personalmente evaluada para garantizar un servicio excepcional, vistas impresionantes y el escenario perfecto para tu celebración."
    },
    dining: {
      title: "Experiencias Gastronómicas",
      description: "Desde restaurantes frente al mar hasta lugares en la azotea, experimenta las mejores ofertas culinarias que muestran los ricos sabores y tradiciones de México.",
      blurb: "Nuestras alianzas con los mejores chefs y restaurantes garantizan una experiencia gastronómica inolvidable para ti y tus invitados."
    },
    cta: {
      title: "¿Listo para planear tu boda de ensueño en {destination}?",
      schedule: "Agenda tu consulta gratuita",
      whatsapp: "WhatsApp"
    },
  },
  cta: {
    begin: 'Comienza tu viaje',
    seeDestinations: 'Ver destinos',
    exploreVenue: 'Explorar Lugar',
    readyToBegin: '¿Listo para comenzar tu viaje?',
    scheduleConsultation: 'Agendar una Consulta',
    consultationDetails: 'Consulta de cortesía de 30 minutos\nInglés y español disponibles',
    stayInspired: 'Mantente Inspirado',
    signUpForNewsletter: 'Suscríbete a nuestro boletín para recibir inspiración exclusiva, consejos de planificación y destinos destacados.',
    subscribe: 'Suscribirse',
    meetYourPlanners: 'Conoce a tus Organizadores',
  },
  resources: {
    pageTitle: 'Recursos',
    pageDescription: 'Todo lo que necesitas para planificar tu boda de destino perfecta en México.',
    faqTitle: 'Preguntas Frecuentes',
    faqDescription: 'Encuentra respuestas a preguntas comunes sobre bodas de destino en México.',
    topVenuesTitle: 'Top 10 Venues en México',
    topVenuesDescription: 'Descubre los lugares para bodas más impresionantes y únicos en México.',
    destinationGuidesTitle: 'Guías de Destinos',
    destinationGuidesDescription: 'Explora nuestras guías completas de los destinos más populares para bodas en México.',
    ctaTitle: '¿Listo para Comenzar a Planificar tu Boda Soñada?',
    ctaDescription: 'Déjanos ayudarte a crear la experiencia perfecta para tu boda de destino en México.',
    ctaButton: 'Comenzar',
    topVenuesHeroTitle: 'Los 10 Mejores Venues para Bodas en México',
    topVenuesIntro1: 'México es reconocido por su calidez, paisajes impresionantes y hospitalidad sofisticada. Para parejas que buscan una celebración única, estos diez venues son el estándar de oro, cada uno ofreciendo su propia mezcla única de exclusividad, belleza y servicio impecable. Desde playas prístinas hasta ciudades históricas, esta lista es tu guía definitiva de lo mejor del país.',
    topVenuesIntro2: 'Cada uno de estos venues ofrece una mezcla única de lujo, romance y auténtico encanto mexicano. Ya sea que te atraigan las aguas turquesas del Caribe, los acantilados dramáticos de Los Cabos o la elegancia colonial de las ciudades históricas de México, estos venues prometen transformar tu boda en una celebración inolvidable. Con servicio de clase mundial, escenarios impresionantes y atención a cada detalle, tu día especial será simplemente mágico.',
    whyWeLoveIt: 'Por qué nos encanta:',
    ratingLabel: 'Calificación:',
    topVenuesOutro: '¿Sigues buscando "el indicado"? Cuéntanos tu visión—hay un venue soñado en México para cada pareja y cada historia.',
    aboutAssemblageTitle: 'Acerca de Assemblage',
    aboutAssemblageDesc: 'Somos una empresa boutique de planificación de bodas especializada en bodas de destino de lujo en México. Nuestro equipo de planificadores experimentados asegura que cada detalle sea perfecto.',
    learnMore: 'Conoce más sobre nosotros',
    readyToFindVenue: '¿Listo para encontrar tu venue perfecto?',
    ourPlannersHelp: 'Nuestros planificadores expertos pueden ayudarte a descubrir y asegurar la ubicación ideal para tu boda soñada.',
    scheduleConsultation: 'Agenda una Consulta'
  },
  faq: {
    pageTitle: 'Preguntas Frecuentes',
    pageDescription: 'Encuentra respuestas a las preguntas más comunes sobre bodas de destino en México, la planeación y trabajar con Assemblage.',
    foreignerTab: 'Parejas Internacionales',
    domesticTab: 'Parejas Mexicanas',
    foreignerQuestions: [
      { q: '¿Por qué elegir Assemblage en vez de un paquete de wedding planner de resort?', a: 'Assemblage ofrece una planeación boutique verdaderamente personalizada, con acceso a los mejores venues, proveedores y experiencias en todo México—no solo en un resort. Defendemos tu visión, negociamos por ti y te damos asesoría creativa e imparcial. Los planners de resort están limitados a su propiedad y pueden tener lealtades divididas, mientras que Assemblage está dedicado únicamente a ti y a tu celebración.' },
      { q: '¿Pueden los extranjeros casarse legalmente en México?', a: 'Sí, los extranjeros pueden casarse legalmente en México. Te ayudamos con todos los trámites y requisitos.' },
      { q: '¿Qué documentos necesitamos para una boda legal en México?', a: 'Necesitarán pasaportes vigentes, actas de nacimiento y constancia de soltería. Te guiamos en todo el proceso.' },
      { q: '¿Nuestro matrimonio será válido en nuestro país de origen?', a: 'Sí, siempre que sigan el proceso legal en México, su matrimonio será reconocido internacionalmente.' },
      { q: '¿Debemos estar en México varios días antes de la boda?', a: 'Algunas regiones requieren que estén en México algunos días antes de la ceremonia. Les asesoramos según su destino.' },
      { q: '¿Podemos tener una ceremonia simbólica en vez de legal?', a: '¡Por supuesto! Muchas parejas eligen una ceremonia simbólica por facilidad y flexibilidad, y luego realizan el trámite legal en su país.' },
      { q: '¿En qué idioma será la ceremonia?', a: 'La ceremonia puede ser en inglés, español o ambos. Contamos con oficiantes bilingües si lo desean.' },
      { q: '¿Debemos traducir nuestros documentos?', a: 'Algunos documentos pueden requerir traducción oficial al español. Te indicaremos exactamente qué se necesita.' },
      { q: '¿Algún consejo de viaje para nuestros invitados?', a: 'Recomendamos reservar vuelos y hospedaje con anticipación. Podemos ayudar con tarifas grupales y logística de viaje.' },
      { q: '¿Qué deben saber los invitados internacionales sobre viajar a México?', a: 'Recomendamos revisar la vigencia del pasaporte, requisitos de visa y avisos de viaje para México. Podemos proporcionar cartas de invitación si se requieren para la visa.' },
      { q: '¿Hay vuelos directos al destino de la boda?', a: 'La mayoría de los destinos principales en México tienen vuelos directos desde EE. UU., Canadá y Europa. Podemos recomendar las mejores rutas y aeropuertos.' },
      { q: '¿Se ofrece transporte desde el aeropuerto para los invitados?', a: 'Podemos organizar traslados grupales o recomendar opciones confiables de transporte del aeropuerto al hotel o lugar del evento.' },
      { q: '¿Qué hay sobre salud y seguridad para los invitados internacionales?', a: 'Proporcionamos información actualizada sobre salud y seguridad, incluyendo seguro de viaje, vacunas recomendadas y contactos de emergencia locales.' },
      { q: '¿Pueden ayudar con tarifas de hotel para grupos?', a: '¡Sí! Negociamos tarifas grupales y podemos coordinar bloques de habitaciones para sus invitados en hoteles recomendados.' }
    ],
    domesticQuestions: [
      { q: '¿Por qué elegir Assemblage en vez de un paquete de wedding planner de resort?', a: 'Assemblage ofrece una planeación boutique verdaderamente personalizada, con acceso a los mejores venues, proveedores y experiencias en todo México—no solo en un resort. Defendemos tu visión, negociamos por ti y te damos asesoría creativa e imparcial. Los planners de resort están limitados a su propiedad y pueden tener lealtades divididas, mientras que Assemblage está dedicado únicamente a ti y a tu celebración.' },
      { q: '¿Pueden los ciudadanos mexicanos casarse en otro estado?', a: 'Sí, los ciudadanos mexicanos pueden casarse en cualquier estado. Te ayudamos con los trámites y requisitos locales.' },
      { q: '¿Qué documentos necesitan los ciudadanos mexicanos para una boda?', a: 'Necesitarán acta de nacimiento, identificación oficial y constancia de soltería. Te asistimos con todos los detalles.' },
      { q: '¿Podemos tener ceremonia religiosa y civil?', a: 'Sí, pueden tener ambas. Coordinamos con autoridades locales e instituciones religiosas.' },
      { q: '¿Ofrecen planeación para parejas locales?', a: '¡Por supuesto! Ofrecemos servicios completos de planeación tanto para bodas locales como de destino.' },
      { q: '¿Podemos tener una ceremonia simbólica?', a: 'Sí, las ceremonias simbólicas son populares y pueden personalizarse a su gusto.' },
      { q: '¿Nuestra ceremonia puede ser bilingüe?', a: '¡Por supuesto! Podemos organizar oficiantes y materiales bilingües.' },
      { q: '¿Debemos traducir algún documento?', a: 'Si algún documento es del extranjero, puede requerir traducción. Te asesoramos.' },
      { q: '¿Qué deben saber nuestros invitados sobre viajar dentro de México?', a: 'Ofrecemos consejos de viaje, tarifas grupales y recomendaciones locales para tus invitados.' }
    ],
    questions: [
      { q: '¿Cuál es la mejor época del año para casarse en México?', a: 'La primavera (marzo-mayo) y el otoño (septiembre-noviembre) ofrecen el clima perfecto. El verano es más cálido pero tiene tarifas más bajas, y el invierno es mágico con decoración festiva.' },
      { q: '¿Con cuánta anticipación debemos reservar nuestra boda?', a: 'Recomendamos reservar con 12-18 meses de anticipación, especialmente para fechas y lugares populares.' },
      { q: '¿Pueden ayudar con los requisitos legales para casarse en México?', a: '¡Sí! Nuestro equipo gestiona toda la documentación y coordinación para ceremonias civiles y religiosas.' },
      { q: '¿Ofrecen planeación parcial o coordinación solo el día del evento?', a: 'Sí, ofrecemos una variedad de paquetes de planeación para adaptarnos a tus necesidades.' },
      { q: '¿Pueden ayudar con alojamiento y transporte para los invitados?', a: '¡Por supuesto! Trabajamos con los mejores hoteles y proveedores de transporte para asegurar una experiencia perfecta para tus invitados.' },
      { q: '¿En qué idiomas trabajan?', a: 'Nuestro equipo habla inglés, español y más. Garantizamos comunicación clara con todos los proveedores e invitados.' },
      { q: '¿Cómo manejan las restricciones alimentarias?', a: 'Trabajamos de cerca con nuestros socios de catering para atender todas las necesidades alimentarias.' }
    ]
  },
}; 